export default __webpack_public_path__ + "static/Mockup-6e917f8e1c7b262e4ed2e0c6623d94f4.png";